export default "__VITE_ASSET__ljDqaw4P__"